
import React, { useState, useRef, useEffect } from 'react';

///style MUI
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Tooltip from '@mui/material/Tooltip';
///style bootstrap
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
///icon
import { TbDrone } from "react-icons/tb";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FolderOffIcon from '@mui/icons-material/FolderOff';


import TaskIcon from '@mui/icons-material/Task';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import GppBadIcon from '@mui/icons-material/GppBad';
import CancelIcon from '@mui/icons-material/Cancel';

export default function Pilot_Status_User(props) {
    const main_status = [props.status]; // รับเป็น Array
    // const [main_status, setmain_status] = useState(['อนุมัติ']);
    return (
        <>
            <div className='center' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                {Case_Status(main_status[0])}
            </div>
        </>
    )
}

const Case_Status = (status) => {

    switch (status) {
        case "ไม่อนุมัติ":
            return <NeverAuthrized />
        case "อนุมัติ":
            return <Complete />
        case "เอกสารไม่ถูกต้อง":
            return <Rescinded_Awaitng_Status />
        case "หมดอายุ":
            return <DeAuthrized_Status />
        default:
            return <Modal_Status status={status} />

    }
}
const Modal_Status = (props) => {

    const checklist = [
        ['ยื่นคำขอ'], ['ไม่อนุมัติ', 'อนุมัติ']
    ]
    const [data_list_display, setdata_list_display] = useState([]);
    function process_checklist(status) {

        let data_list = [];

        if (status === "ยื่นคำขอ") {
            data_list = [{ Label: "ยื่นคำขอ", completed: false, active: true, error: false, icon: 1 }, //pending
            { Label: "อนุมัติเอกสาร", completed: false, active: false, error: false, icon: 2 },
            ]
        }
        if (status === "อนุมัติ") {
            data_list = [{ Label: "คำขออนุมัติ", completed: true, active: false, error: false, icon: 1 },
            { Label: "อนุมัติเอกสาร", completed: true, active: false, error: false, icon: 2 },//pending
            ]
        }

        return data_list;
    }
    function IconStep(props) {
        const { label, active, completed } = props;
        let icon;
        if (completed && !active) {
            icon = <TaskIcon style={{ width: "36px", height: "36px", color: "green", opacity: 0.9 }} />;
        } else if (completed && active) {
            icon = <TaskIcon style={{ width: "36px", height: "36px", color: "green", opacity: 0.9 }} />;
        } else if (!completed && active) {
            icon = <PendingActionsIcon style={{ width: "36px", height: "36px", color: "orange" }} />;
        } else {
            icon = <AssignmentIcon style={{ width: "36px", height: "36px", color: "gray", opacity: 0.9 }} />;
        }

        return icon;
    }
    useEffect(() => {
        let datalist = process_checklist(props.status);
        setdata_list_display(datalist)
    }, [props.status]);


    return (
        <>
            <Stepper alternativeLabel  >
                {data_list_display.map((item) => (
                    <Step key={item.Label}>
                        <Tooltip title={<span style={{ fontSize: "16px", fontFamily: "Kanit" }}>{item.Label}</span>} placement="top" >
                            <StepLabel style={{ fontSize: "12px" }} StepIconComponent={(props) => <IconStep label={item.Label} {...item} />}>{ }</StepLabel>
                        </Tooltip>

                    </Step>
                ))}
            </Stepper>
        </>
    );

}

const NeverAuthrized = () => {
    return (
        <Tooltip title={<span style={{ fontSize: "16px", fontFamily: "Kanit" }}>ไม่อนุมัติ</span>} placement="top" >
            <CancelIcon style={{ width: "36px", height: "36px", color: "red", opacity: 0.8 }} />
        </Tooltip>
    );
}
const Complete = () => {
    return (

        <Tooltip title={<span style={{ fontSize: "16px", fontFamily: "Kanit" }}>อนุมัติ</span>} placement="top" >
            <TaskIcon style={{ width: "36px", height: "36px", color: "green", opacity: 0.9 }} />
        </Tooltip>

    );
}
const Rescinded_Awaitng_Status = () => {
    return (<Tooltip title={<span style={{ fontSize: "16px", fontFamily: "Kanit" }}>เอกสารไม่ถูกต้อง</span>} placement="top" >
        <GppBadIcon style={{ width: "39px", height: "39px", color: "red", opacity: 0.85 }} />
    </Tooltip>);
}
const DeAuthrized_Status = () => {
    return (

        <Tooltip title={<span style={{ fontSize: "16px", fontFamily: "Kanit" }}>หมดอายุ</span>} placement="top" >
            <RuleFolderIcon style={{ width: "40px", height: "40px", color: "orange", opacity: 0.9 }} />
        </Tooltip>);
}